export function Login(props) {
    function submitLogInACB(event){
        event.preventDefault();  // Förhindra form submit
        props.signIn();
    }
    function updateEmailACB(event) {
        props.setEmail(event.target.value);
        console.log(event.target.value);
    }
    function updatePasswordACB(event) {
        props.setPassword(event.target.value);
        console.log(event.target.value);
    }
    return (
        <form onSubmit={submitLogInACB} className="space-y-4">            
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Email</label>
                {props.emailError && <span className="text-red-700 text-sm mb-1">{props.emailError}</span>}
              </div>
              <input
                type="email"
                placeholder="Enter email"
                onChange={updateEmailACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            
            <div>
              <div>
                <label className="block text-blue-900 mb-1">Password</label>
                {props.passwordError && <span className="text-red-700 text-sm mb-1">{props.passwordError}</span>}
              </div>
              <input
                type="password"
                placeholder="Enter password"
                onChange={updatePasswordACB}
                className="w-full px-4 py-2 !border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <button
              type="submit"
              className="flex items-center justify-center w-full py-3 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all shadow-md"
            >
              Sign In
            </button>
          </form>
    );    
}
